import { fetchApi } from '@/config/axiosSetting.ts';
import { ActivateQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/activate/activateQuery.type';

export const ActivateQueryFunction = (
  id: string,
  params?: ActivateQueryParamsType,
) =>
  fetchApi({
    method: 'PATCH',
    url: `/property/reports/${id}/accident_users/damaged/activate/`,
    data: params,
  });
